// Empêcher le double chargement des custom elements
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;
      
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      
      // Éviter les event listeners dupliqués
      if (!cartLink.hasAttribute('data-cart-drawer-initialized')) {
        cartLink.setAttribute('data-cart-drawer-initialized', 'true');
        cartLink.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(cartLink);
        });
        cartLink.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            this.open(cartLink);
          }
        });
      }
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => {
        this.classList.add('animate', 'active');
        const cartDrawerItems = this.querySelector('cart-drawer-items');
        if (cartDrawerItems) {
          cartDrawerItems.updateCartUpsellToggleState();
          cartDrawerItems.updateCartUpsellVisibility();
        }
      });

      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true }
      );

      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');

      if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }

      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });

      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderContents(parsedState) {
      this.querySelector('.drawer__inner').classList.contains('is-empty') &&
        this.querySelector('.drawer__inner').classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (sectionElement) {
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }
      });

      // Déclencher l'animation de l'icône du panier
      this.animateCartIcon();

      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });
    }

    // Nouvelle méthode pour animer l'icône du panier
    animateCartIcon() {
      const cartIcon = document.querySelector('#cart-icon-bubble');
      if (cartIcon) {
        // Retirer l'animation existante si présente
        cartIcon.classList.remove('cart-icon-shake');
        
        // Forcer un reflow pour redémarrer l'animation
        void cartIcon.offsetWidth;
        
        // Ajouter la classe d'animation
        cartIcon.classList.add('cart-icon-shake');
        
        // Retirer la classe après l'animation
        setTimeout(() => {
          cartIcon.classList.remove('cart-icon-shake');
        }, 600);
      }
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}

if (!customElements.get('cart-drawer-items')) {
  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
    }
  }

  customElements.define('cart-drawer-items', CartDrawerItems);
}

// Ajouter les styles CSS pour l'animation du panier (si pas déjà présents)
if (!document.getElementById('cart-drawer-animation-styles')) {
  const style = document.createElement('style');
  style.id = 'cart-drawer-animation-styles';
  style.textContent = `
    @keyframes cartShake {
      0%, 100% { transform: translateX(0); }
      10%, 30%, 50%, 70%, 90% { transform: translateX(-4px); }
      20%, 40%, 60%, 80% { transform: translateX(4px); }
    }
    
    @keyframes cartPop {
      0% { transform: scale(1); }
      50% { transform: scale(1.3); }
      100% { transform: scale(1); }
    }
    
    .cart-icon-shake {
      animation: cartShake 0.5s ease-in-out;
    }
    
    #cart-icon-bubble .cart-count-bubble {
      transition: transform 0.3s ease;
    }
    
    .cart-icon-shake .cart-count-bubble {
      animation: cartPop 0.4s ease-in-out;
    }
  `;
  document.head.appendChild(style);
}

// Fonction globale pour animer l'icône du panier (accessible partout)
window.animateCartIcon = function() {
  const cartIcon = document.querySelector('#cart-icon-bubble');
  if (cartIcon) {
    cartIcon.classList.remove('cart-icon-shake');
    void cartIcon.offsetWidth; // Force reflow
    cartIcon.classList.add('cart-icon-shake');
    setTimeout(() => {
      cartIcon.classList.remove('cart-icon-shake');
    }, 600);
  }
};

// Fonction pour mettre à jour le compteur du panier
window.updateCartBubble = function() {
  return fetch('/?sections=cart-icon-bubble')
    .then(response => response.json())
    .then(data => {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble && data['cart-icon-bubble']) {
        const newContent = new DOMParser()
          .parseFromString(data['cart-icon-bubble'], 'text/html')
          .querySelector('.shopify-section');
        
        if (newContent) {
          cartIconBubble.innerHTML = newContent.innerHTML;
        }
      }
    })
    .catch(err => console.error('Erreur mise à jour panier:', err));
};

// Intercepter les requêtes fetch vers /cart/add.js pour déclencher l'animation
if (!window._cartFetchIntercepted) {
  window._cartFetchIntercepted = true;
  
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];
    const urlString = typeof url === 'string' ? url : url.url || '';
    
    return originalFetch.apply(this, args).then(response => {
      // Si c'est une requête d'ajout au panier réussie
      if (urlString.includes('/cart/add') && response.ok) {
        // Cloner la réponse pour pouvoir la lire sans la consommer
        const clonedResponse = response.clone();
        
        // Mettre à jour le compteur du panier et déclencher l'animation
        setTimeout(() => {
          window.updateCartBubble().then(() => {
            window.animateCartIcon();
          });
        }, 100);
      }
      return response;
    });
  };
}

// Intercepter XMLHttpRequest pour les thèmes qui l'utilisent
if (!window._cartXHRIntercepted) {
  window._cartXHRIntercepted = true;
  
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;
  
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this._cartAddRequest = url && url.includes('/cart/add');
    return originalXHROpen.apply(this, [method, url, ...rest]);
  };
  
  XMLHttpRequest.prototype.send = function(...args) {
    if (this._cartAddRequest) {
      this.addEventListener('load', function() {
        if (this.status >= 200 && this.status < 300) {
          setTimeout(() => {
            window.updateCartBubble().then(() => {
              window.animateCartIcon();
            });
          }, 100);
        }
      });
    }
    return originalXHRSend.apply(this, args);
  };
}